var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGradientCheckmark = function SvgGradientCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_901_1205)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 18.8805L7.6 14.7014L6.2 16.0944L11.8 21.6666L23.8 9.72629L22.4 8.33325L11.8 18.8805Z",
    fill: "#FBFBFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_901_1205",
    x1: -5.43932e-8,
    y1: 13.6028,
    x2: 41.6683,
    y2: 14.0412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })))));
};
export { SvgGradientCheckmark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl85MDFfMTIwNSkiLz4KPHBhdGggZD0iTTExLjggMTguODgwNUw3LjYgMTQuNzAxNEw2LjIgMTYuMDk0NEwxMS44IDIxLjY2NjZMMjMuOCA5LjcyNjI5TDIyLjQgOC4zMzMyNUwxMS44IDE4Ljg4MDVaIiBmaWxsPSIjRkJGQkZGIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfOTAxXzEyMDUiIHgxPSItNS40MzkzMmUtMDgiIHkxPSIxMy42MDI4IiB4Mj0iNDEuNjY4MyIgeTI9IjE0LjA0MTIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzZBNERCQyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGMjk5NEEiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";